// extracted by mini-css-extract-plugin
export var errorIcon = "_nf-1";
export var nameLogo = "_nf-0";